import { useEffect, useState, useMemo } from 'react'
import Modal from '../../../components/utils/Model';
import Button from '../../../components/utils/Button';
import { useDispatch, useSelector } from 'react-redux';
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions'
import { useForm } from "react-hook-form";
import Alert from '../../../components/utils/Alert';
import authActions from '../../../redux/auth/actions';
import moment from 'moment';

const { refundDailyPlanRequest, resetDailyPlan } = dailyPlanRequestActions;

const DailyPlanRefundDetails = ({ row, modal, close }) => {
    const dispatch = useDispatch();
    const { getUserDataByToken } = authActions;
    const {
        refundDailyPlanRequestLoading,
        refundDailyPlanRequestError,
        refundDailyPlanRequestMessage
    } = useSelector((state) => state.dailyPlanRequest);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');


    const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: {} });

    useEffect(() => {
        dispatch(resetDailyPlan());
    }, []);

    useEffect(() => {
        if (refundDailyPlanRequestError !== null && refundDailyPlanRequestError !== undefined) {
            displayAlert(refundDailyPlanRequestError, 'alert-danger');
        }
        if (refundDailyPlanRequestMessage !== null && refundDailyPlanRequestMessage !== undefined) {
            close();
        }
    }, [refundDailyPlanRequestError, refundDailyPlanRequestMessage]);

    useEffect(() => {
        dispatch(getUserDataByToken());
    }, [])

    const onSubmit = (data) => {
        data.RefundedDays = refundedDays;
        data.DailyPlanRequestID = row.ID;
        // console.log('data ', data);
        // dispatch(refundDailyPlanRequest(data, search));
    }

    const displayAlert = (text, type) => {
        setShowAlert(true);
        setAlertText(text);
        setAlertType(type);
        dispatch(resetDailyPlan());
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetDailyPlan());
    }

    const refundedDays = useMemo(() => {
        if (row) {
            let RequestedToDate = moment(moment(row.RequestedToDate).format('YYYY-MM-DD'));
            let currentDate = moment(moment().format('YYYY-MM-DD'));
            const diffInDays = RequestedToDate.diff(currentDate, 'days');
            return diffInDays;
        } else {
            return 0
        }
    }, [row]);

    return (
        <Modal
            showModal={modal}
            title={`REFUND INFO : ${row.TransactionID}`}
            onHide={() => close()}
            width={500}
            showFooter={false}
        >
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-lg-4 mb-3">
                        <label>Refunded Date</label>
                        <p>{moment(new Date(row.RefundedDate)).format('YYYY-MM-DD')}</p>
                    </div>

                    <div className="col-lg-4 mb-3 d-flex flex-column">
                        <label>Refunded Amount</label>
                        <p>{row.RefundedAmount}</p>
                    </div>

                    <div className="col-lg-4 mb-3 d-flex flex-column">
                        <label>Refunded For</label>
                        <p>{row.RefundedDays > 1 ? `${row.RefundedDays} Days` : `${row.RefundedDays} Day`}</p>
                    </div>
                </div>

                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={() => close()}>Close</button>
                        {/* <Button title="Submit" loading={refundDailyPlanRequestLoading} buttonClass="btn btn-primary" buttonType='submit' /> */}
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default DailyPlanRefundDetails;